<template>
  <section>
    <loading
      class="custom-loading-overlay"
      :active="isLoading"
      :color="loadingColor"
      :isFullPage="true"
    ></loading>
    <div
      id="menu-main"
      data-menu-active="nav-homes"
      style="width: 280px; z-index: 999999px !important"
      class="offcanvas offcanvas-start offcanvas-detached rounded-m"
    >
      <div
        class="card card-style bg-23 mb-3 rounded-m mt-3"
        data-card-height="150"
      >
        <div class="card-top m-3">
          <a
            href="#"
            data-bs-dismiss="offcanvas"
            class="icon icon-xs bg-theme rounded-s color-theme float-end"
            ><i class="bi bi-caret-left-fill"></i
          ></a>
        </div>
        <!-- <div class="card-bottom p-3">
          <h1 class="color-white font-20 font-700 mb-n2">Duo Mobile</h1>
          <p class="color-white font-12 opacity-70 mb-n1">
            Bootstrap 5 Mobile PWA
          </p>
        </div> -->
        <div class="card-overlay bg-gradient-fade rounded-0"></div>
      </div>

      <router-link to="/editar-perfil">
        <div class="bg-theme mx-3 rounded-m shadow-m mt-3 mb-3">
          <div class="d-flex px-2 pb-2 pt-2">
            <div>
              <a href="#">
                <!-- <img
                  v-if="previewImage"
                  :src="previewImage"
                  width="45"
                class="rounded-s"
                /> -->
                <img
                  :src="$store.state.user.photo"
                  width="45"
                  class="rounded-s"
                />
              </a>
            </div>
            <div class="ps-2 align-self-center">
              <h5 class="ps-1 mb-0 line-height-xs pt-1">
                {{ $store.state.user.usuario_nome }}
              </h5>
              <!-- <h6 class="ps-1 mb-0 font-400 opacity-40">Front End Designer</h6> -->
            </div>
            <div class="ms-auto">
              <!-- <a href="#" data-bs-toggle="dropdown" class="icon icon-m ps-3"
              ><i class="bi bi-three-dots-vertical font-18 color-theme"></i
            ></a> -->
              <!-- <div class="dropdown-menu bg-transparent border-0 mt-n1 ms-3">
              <div class="card card-style rounded-m shadow-xl mt-1 me-1">
                <div
                  class="list-group list-custom list-group-s list-group-flush rounded-xs px-3 py-1"
                >
                  <a
                    href="page-profile-admin.html"
                    class="color-theme opacity-70 list-group-item py-1"
                    ><strong class="font-500 font-12">Your Profile</strong
                    ><i class="bi bi-chevron-right"></i
                  ></a>
                  <a
                    href="page-activity.html"
                    class="color-theme opacity-70 list-group-item py-1"
                    ><strong class="font-500 font-12">Notifications</strong
                    ><i class="bi bi-chevron-right"></i
                  ></a>
                  <a
                    href="page-login-2.html"
                    class="color-theme opacity-70 list-group-item py-1"
                    ><strong class="font-500 font-12">Log Out</strong
                    ><i class="bi bi-chevron-right"></i
                  ></a>
                </div>
              </div>
            </div> -->
            </div>
          </div>
        </div>
      </router-link>

      <span class="menu-divider mt-4"></span>
      <div class="menu-list">
        <div class="card card-style rounded-m p-3 py-2 mb-0">
          <router-link to="/solicitar-atendimento">
            <i
              class="gradient-red shadow-bg shadow-bg-xs bi bi-telephone-fill"
            ></i>
            <span>Chamar SAMU</span>
            <i class="bi bi-chevron-right"></i>
          </router-link>
        </div>
      </div>

      <br />

      <span class="menu-divider">MENU</span>
      <div class="menu-list">
        <div class="card card-style rounded-m p-3 py-2 mb-0">
          <router-link to="/dashboard" id="nav-homes"
            ><i
              class="gradient-blue shadow-bg shadow-bg-xs bi bi-house-fill"
            ></i
            ><span>Início</span><i class="bi bi-chevron-right"></i
          ></router-link>
          <router-link to="editar-perfil" id="nav-homes"
            ><i
              class="gradient-orange shadow-bg shadow-bg-xs bi bi-person-fill"
            ></i
            ><span>Informações pessoais</span><i class="bi bi-chevron-right"></i
          ></router-link>
          <!-- <router-link to="/pacientes"
            ><i
              class="gradient-teal shadow-bg shadow-bg-xs bi bi-people-fill"
            ></i
            ><span>Favoritos</span><i class="bi bi-chevron-right"></i
          ></router-link> -->
          <router-link to="/ultimas_solicitacoes"
            ><i
              class="gradient-magenta shadow-bg shadow-bg-xs bi bi-people-fill"
            ></i
            ><span>Histórico das solicitações</span
            ><i class="bi bi-chevron-right"></i
          ></router-link>
          <!-- <router-link to="/quando-chamar-o-samu"
            ><i class="gradient-green shadow-bg shadow-bg-xs bi bi-question"></i
            ><span>Quando acionar o SAMU?</span
            ><i class="bi bi-chevron-right"></i
          ></router-link> -->
          <router-link to="/sobre"
            ><i
              class="gradient-brown shadow-bg shadow-bg-xs bi bi-info-circle-fill"
            ></i
            ><span>Sobre</span><i class="bi bi-chevron-right"></i
          ></router-link>
          <!-- <a href="index-contact.html" id="nav-mails"
            ><i
              class="gradient-magenta shadow-bg shadow-bg-xs bi bi-envelope-fill"
            ></i
            ><span>Contact</span><i class="bi bi-chevron-right"></i
          ></a> -->
        </div>
      </div>

      <span class="menu-divider mt-4"></span>
      <div @click="logout" class="menu-list">
        <div class="card card-style rounded-m p-3 py-2 mb-0">
          <a href="#">
            <i
              class="gradient-highlight shadow-bg shadow-bg-xs bi bi-box-arrow-right"
            ></i>
            <span>Sair</span>
            <i class="bi bi-chevron-right"></i>
          </a>
          <!-- <a href="#" data-toggle-theme data-trigger-switch="switch-1">
            <i
              class="gradient-dark shadow-bg shadow-bg-xs bi bi-moon-fill font-13"
            ></i>
            <span>Dark Mode</span>
            <div class="form-switch ios-switch switch-green switch-s me-2">
              <input
                type="checkbox"
                data-toggle-theme
                class="ios-input"
                id="switch-1"
              />
              <label class="custom-control-label" for="switch-1"></label>
            </div>
          </a> -->
        </div>
      </div>

      <!-- <span class="menu-divider mt-4">Messages</span>
      <div class="menu-content px-3">
        <div class="card card-style rounded-m p-2 mx-0 bg-theme mb-0">
          <div class="menu-list">
            <a href="#"
              ><img
                src="images/avatars/6s.png"
                alt="img"
                class="gradient-orange"
              /><span class="font-500 color-theme">Olivia Orange</span
              ><em class="badge badge-s bg-red-dark">3</em></a
            >
            <a href="#"
              ><img
                src="images/avatars/2s.png"
                alt="img"
                class="gradient-green"
              /><span class="font-500 color-theme">Marcus Green</span
              ><em class="badge badge-s bg-red-dark">5</em></a
            >
            <a href="#"
              ><img
                src="images/avatars/5s.png"
                alt="img"
                class="gradient-blue"
              /><span class="font-500 color-theme">Danny Blueish</span
              ><em class="badge badge-s bg-red-dark">1</em></a
            >
          </div>
        </div>
      </div> -->

      <span class="menu-divider mt-4"></span>
      <div class="menu-content px-3">
        <!-- <div class="card card-style rounded-m p-2 mx-0 bg-theme">
          <a href="#">
            <div class="d-flex">
              <div class="align-self-center">
                <img
                  src="images/pictures/14s.jpg"
                  class="rounded-s me-2"
                  width="60"
                  alt="img"
                />
              </div>
              <div class="align-self-center">
                <h5 class="font-14 mb-0 ps-1 pt-1">Duo 3.0 Released</h5>
                <p class="ps-1 pb-1 mb-0 font-11 line-height-s opacity-70">
                  New design, more components. Bootstrap 5 and Vanilla JS.
                </p>
              </div>
            </div>
          </a>
          <div class="mb-2"></div>
          <a href="#">
            <div class="d-flex">
              <div class="align-self-center">
                <img
                  src="images/pictures/5s.jpg"
                  class="rounded-s me-2"
                  width="60"
                  alt="img"
                />
              </div>
              <div class="align-self-center">
                <h5 class="font-14 mb-0 ps-1 pt-1">PWA Ready</h5>
                <p class="ps-1 pb-1 mb-0 font-11 line-height-s opacity-70">
                  Add Duo to your home screen and enjoy it as you would a native
                  app.
                </p>
              </div>
            </div>
          </a>
          <div class="mb-2"></div>
          <a href="#">
            <div class="d-flex">
              <div class="align-self-center">
                <img
                  src="images/pictures/11s.jpg"
                  class="rounded-s me-2"
                  width="60"
                  alt="img"
                />
              </div>
              <div class="align-self-center">
                <h5 class="font-14 mb-0 ps-1 pt-1">Care & Quality</h5>
                <p class="ps-1 pb-1 mb-0 font-11 line-height-s opacity-70">
                  We love all our customers, and we're always here to help out.
                </p>
              </div>
            </div>
          </a>
        </div> -->
      </div>

      <p
        class="text-center mb-0 mt-n3 pb-3 font-9 text-uppercase font-600 color-theme"
      >
        DESENVOLVIDO POR IT4D - Tecnologia para Decisão
      </p>
    </div>
  </section>
</template>

<script>
import Loading from "vue-loading-overlay";
export default {
  data() {
    return {
      authenticated: false,
      previewImage: null,
      locationError: false,
      isLoading: false,
      loadingColor: "#5D9CEC"
    };
  },
  components: {
    Loading
  },
  props: ["menu"],
  methods: {
    checkLocation() {
      if (!navigator.geolocation) {
        // Geolocalização não suportada
        this.locationError = true;
      } else {
        navigator.geolocation.getCurrentPosition(
          position => {
            // Localização bem-sucedida
            console.log("Localização obtida:", position);
            this.locationError = false; // Resetar o erro se a localização foi obtida
          },
          error => {
            // Erro ao obter a localização
            console.error("Erro ao obter a localização:", error);
            this.locationError = true; // Ativar a mensagem de erro se a localização não puder ser obtida
          }
        );
      }
    },
    logout() {
      let self = this;
      self.isLoading = true;

      let api = this.$store.state.api + "logout";

      self.$http
        .post(api)
        .then(response => {
          localStorage.removeItem("token");
          localStorage.removeItem("usuario_id");

          self.isLoading = false;

          const redirectUri = encodeURIComponent(
            window.location.origin + "/login"
          );
          window.location.href =
            "https://sso.acesso.gov.br/logout?post_logout_redirect_uri=https://samudigitalrio.fs.rj.gov.br/api/v1/logout";
        })
        .catch(error => {
          this.errors = error.response.data.errors;
          self.isLoading = false;
          this.$message("Erro", "Erro ao realizar logout", "error");
        });
    },
    sobre() {
      let self = this;
      self.$router.push({ path: "/sobre" });
    }
  },
  mounted() {
    this.checkLocation();
    this.authenticated = this.$store.getters.authenticated;
  }
};
</script>

<style scoped>
/* CUSTOMIZACOES VUE LOADING */
.custom-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  backdrop-filter: blur(3px);
  opacity: 0.98;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.custom-loading-spinner {
  width: 100px;
  height: 100px;
  z-index: 10000;
}

/* Corrige alinhamento dos ícones Bootstrap Icons dentro dos círculos do menu */
.menu-list a i.bi:first-child {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  line-height: 1 !important;
}

.menu-list a i.bi:first-child::before {
  vertical-align: 0 !important;
  line-height: 1 !important;
  font-size: 16px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/LeftNavbar.vue